import type { FeedbackMessages } from './en';

const th: FeedbackMessages = {
  qualified: {
    title: 'ขอบคุณที่เข้าร่วมการศึกษานี้จนเสร็จสมบูรณ์!',
    body1: 'ท่านสามารถปิดหน้าต่างเบราว์เซอร์ได้',
    body2: 'เราหวังว่าจะได้พบท่านอีกในเร็ววันนี้',
    refCode: 'รหัสอ้างอิง: {code}',
  },
  quotaFull: {
    title: 'การศึกษานี้ปิดรับแล้ว',
    body1: 'ขอบคุณที่ท่านให้ความสนใจในการศึกษาของเรา',
    body2: 'ขออภัย เราได้รับคำตอบครบตามจำนวนที่ต้องการแล้ว',
    body3: 'เราหวังว่าจะได้พบท่านในการศึกษาครั้งต่อไปของเรา!',
    refCode: 'รหัสอ้างอิง: {code}',
  },
  terminated: {
    title: 'ขอบคุณที่ท่านได้แสดงความคิดเห็น!',
    body1:
      'เราหวังว่าจะได้พบท่านอีกในการศึกษาครั้งต่อไปของเรา ขอให้ท่านมีวันที่ดีในระหว่างนี้',
    body2: 'กรุณาปิดหน้าต่างเบราว์เซอร์นี้',
    refCode: 'รหัสอ้างอิง: {code}',
  },
  mismatch: {
    title: 'ขอบคุณสำหรับความสนใจของท่าน',
    body1: 'ขออภัย ท่านไม่อยู่ในกลุ่มเป้าหมายของการศึกษานี้',
    body2: 'ท่านสามารถปิดหน้านี้ได้',
    code: 'รหัส: {code}',
  },
  error: {
    title: 'เราไม่สามารถดำเนินการตามคำขอของท่านได้',
    linkProblemDetailed:
      'ลิงก์ที่ท่านคลิกมีปัญหา กรุณาตรวจสอบว่าลิงก์ในแถบที่อยู่ตรงกับลิงก์ที่ท่านได้รับ แล้วลองใหม่อีกครั้ง',
    linkProblemGeneric: 'ลิงก์ที่ท่านคลิกมีปัญหา กรุณาลองใหม่อีกครั้ง',
    contactPerson:
      'หากปัญหายังคงเกิดขึ้น กรุณาแจ้งให้ผู้ที่ให้ลิงก์แก่ท่านทราบถึงปัญหานี้',
    errorCode: 'รหัสข้อผิดพลาด: {code}',
  },
};

export default th;
